import {
  CarrotPlanFormSelectOption,
  CarrotPlanFormOption,
  MenuItemOptionFields,
  MediaOptionFields,
  FormResponsiveDisplayStatus,
  TopicOptionFields
} from "./hooks/useCarrotPlanMappings"
import { DisplayStatus } from "types/CarrotPlanOptions"

export const HAS_ANSWERED_MEDICAL_QUESTIONS_MSG =
  "This member already answered medical questions. Make sure you want to include this item"
export const RESTRICTED_MSG = "Based on what we know about the member, this option is not available"
export const DUPLICATE_MSG = "You can't include the same item twice in one Carrot Plan"
export const EXISTS_PRIOR_MSG = "This item appeared in a previous Carrot Plan. Make sure you want to include it again."
export const RECOMMENDED_MSG = "Recommended item based on member's responses"
export const REQUIRED_BY_GREGBOT_HELPER_TEXT = "Required by Gregbot."
export const REQUIRED_BY_GREGBOT_PREFIX = "Required by Gregbot. "

export type SelectOption = CarrotPlanFormOption<MenuItemOptionFields | TopicOptionFields | MediaOptionFields>

export function getDisabledOrWarningMessage(option: CarrotPlanFormSelectOption): string {
  const displayStatus = option?.optionMetadata?.displayStatus
  switch (displayStatus) {
    case FormResponsiveDisplayStatus.DUPLICATE_ON_SAME_PLAN:
      return DUPLICATE_MSG
    case DisplayStatus.WARNING_ON_PREVIOUS_CARROT_PLAN:
      return EXISTS_PRIOR_MSG
    case DisplayStatus.WARNING_ALREADY_ANSWERED_MEDICAL_QUESTIONS:
      return HAS_ANSWERED_MEDICAL_QUESTIONS_MSG
    case DisplayStatus.DISABLE:
      return RESTRICTED_MSG
    default:
      return ""
  }
}

export function getRecommendedMessage(option: CarrotPlanFormSelectOption): string {
  if (option?.optionMetadata?.isRecommended) {
    return RECOMMENDED_MSG
  }
  return ""
}

export function getCaptionText(option: SelectOption | undefined): string {
  if (!option) return ""
  if (option.optionMetadata?.isRequired) return REQUIRED_BY_GREGBOT_HELPER_TEXT
  return getDisabledOrWarningMessage(option) || getRecommendedMessage(option) || ""
}
